import React from 'react'
import AboutPostHeader from '../ContactUs/AboutPostHeader'
import Footer from '../LandingPage/Footer'
import Header from '../LandingPage/Header'
import Navbar from '../LandingPage/Navbar'
import UiBox from './UiBox'
const UI = () => {
    const data = [
        {
          font:<i class="fab fa-3x text-primary fa-researchgate"></i>,
          head: "User Research",
          para:"For clients in the design and prospecting phase of a new product, we offer in-depth user research, mockups, user persona development, and thorough UI/UX testing to ensure your app is human-friendly from the start."
        },
        {
            font:<i class="fas fa-3x text-primary fa-audio-description"></i>,
            head: "UX Audit",
            para:"We offer UX auditing services for products that are already in the hands of users so you can see what’s working and what isn’t."
          },
          {
            font:<i class="fas fa-3x text-primary fa-pencil-ruler"></i>,
            head: "Interaction Design",
            para:"We combine the five dimensions of interaction design—words, visuals, spatial layouts, time, and object behavior—into one smooth experience to help you create the best possible user experience."
          },
          {
            font:<i class="fab fa-3x text-primary fa-acquisitions-incorporated"></i>,
            head: "Thoughtful Design",
            para:"Crafting the perfect user experience is nothing short of alchemy. Our team melds user needs, functionality, and aesthetics to create experiences that captivate your customers"
          },
          {
            font:<i class="fas fa-3x text-primary fa-info-circle"></i>,
            head: "Detailed Focus",
            para:"Page flow, visual layout, and the psychological impact of copy all influence your customers’ experience. Our team focuses on each detail to craft the ideal user experience.."
          },
          {
            font:<i class="fab fa-glide fa-3x text-primary"></i>,
            head: "Expert Guidance",
            para:"Our team specializes in understanding your user and creating an experience just for them. From initial designs to audits of existing apps, our team will make sure your app engages your audience and makes them want to stick around."
          },
      ]
      var UiBoxArray = data.map((section) => {
        return (
          <UiBox
            font={section.font}
            head={section.head}
            para={section.para}
          />
        )
      })
        const contact = {
            head: "UI/UX",
            para: "We create Something users  love it",
          };
    return (
        <>
            <Header />
            <Navbar />
            <AboutPostHeader obj={contact}/>
            <div className="container mt-5">
<div className='row'>
{UiBoxArray}

</div>
    </div>
      <Footer />
        </>
    )
}

export default UI
